import React from "react";
import "./ComingSoonModal.scss";
import rocket from "../../assets/rocket.png"
import close from "../../assets/icons/close-black.svg"
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";

const ComingSoonModal = () => {
    const dispatch = useDispatch()
    const onClose = () => {
        dispatch(setIsComing(false))
    }
    return (
        <div className="cs-overlay" onClick={onClose}>
            <div className="cs-box" onClick={(e) => e.stopPropagation()}>
                <img alt="" src={close} className="cs-box-close" onClick={onClose} />
                <div className="cs-box-cn" >
                    <img alt="" src={rocket} className="cs-box-cn-img" />
                    <div className="cs-box-cn-header">Feature Coming Soon</div>
                    <div className="cs-box-cn-subheader">Something exciting is on the way, check back soon!</div>
                </div>

            </div>
        </div>
    );
}
export default ComingSoonModal
